import FfCamIcon from '../images/ff-camera-icon.svg';
import DrCamIcon from '../images/dr-camera-icon.svg';
import PaCamIcon from '../images/pa-camera-icon.svg';
import ReCamIcon from '../images/re-camera-icon.svg';
/* eslint-disable quote-props */
export const STANDARD_DVR_CAMERAS = {
  '1': {
    id: 1,
    channelIndex: 1,
    key: 'ff',
    detailskey: 'forwardFacing',
    linkName: 'forward-camera',
    arrowDirection: 'upward',
    icon: FfCamIcon,
    formOrder: 1//used for displaying the camera views in different order within onDemand form
  },
  '2': {
    id: 2,
    channelIndex: 2,
    key: 'pa',
    detailskey: 'passenger',
    linkName: 'passenger-camera',
    arrowDirection: 'forward',
    textBeforeIcon: true,
    icon: PaCamIcon,
    formOrder: 4
  },
  '3': {
    id: 3,
    channelIndex: 3,
    key: 're',
    detailskey: 'rear',
    linkName: 'rear-camera',
    arrowDirection: 'downward',
    icon: ReCamIcon,
    formOrder: 2
  },
  '4': {
    id: 4,
    channelIndex: 4,
    key: 'dr',
    detailskey: 'driver',
    linkName: 'driver-camera',
    arrowDirection: 'back',
    icon: DrCamIcon,
    formOrder: 3
  }
  
};

export const ADPLUS2_DVR_CAMERAS = {
  '1': {
    id: 1,
    channelIndex: 1,
    key: 'ff',
    detailskey: 'forwardFacing',
    linkName: 'forward-camera',
    arrowDirection: 'upward',
    icon: FfCamIcon,
    formOrder: 1
  },
  '2': {
    id: 2,
    channelIndex: 2,
    key: 'ca',
    detailskey: 'incabin',
    linkName: 'incabin-camera',
    arrowDirection: 'downward',
    icon: ReCamIcon,
    formOrder: 2
  },
  '3': {
    id: 4,
    channelIndex: 4,
    key: 'dr',
    detailskey: 'driver',
    linkName: 'driver-camera',
    arrowDirection: 'back',
    icon: DrCamIcon,
    formOrder: 3
  },  
  '4': {
    id: 3,
    channelIndex: 3,
    key: 'pa',
    detailskey: 'passenger',
    linkName: 'passenger-camera',
    arrowDirection: 'forward',
    textBeforeIcon: true,
    icon: PaCamIcon,
    formOrder: 4
  }
};

export const TWO_CHANNEL_DVR_CAMERAS = {
  '1': {
    id: 1,
    channelIndex: 1,
    key: 'ff',
    detailskey: 'forwardFacing',
    linkName: 'forward-camera',
    arrowDirection: 'upward',
    icon: FfCamIcon,
    formOrder: 1//used for displaying the camera views in different order within onDemand form
  },
  '2': {
    id: 2,
    channelIndex: 2,
    key: 're',
    detailskey: 'rear',
    linkName: 'rear-camera',
    arrowDirection: 'downward',
    icon: ReCamIcon,
    formOrder: 2
  }
};
